/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiUserTasksGetLastSelectedIdParameter,
  ApiUserTasksGetPageParameter,
  BalanceScrollQuery,
  BalanceUnitStatement,
  GetBalanceByUserIdResponse,
  GetBalanceDetailResponse,
  GetBalanceResponse,
  GetBalanceStatementByStudentRequest,
  GetBalanceStatementByUserRequest,
  PaginatedResultOfGetBalanceDetailResponse,
  PaginatedResultOfGetBalanceResponse,
  PostBalanceTransactionRequest,
  Result,
} from '../models/index';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterToJSON,
    BalanceScrollQueryFromJSON,
    BalanceScrollQueryToJSON,
    BalanceUnitStatementFromJSON,
    BalanceUnitStatementToJSON,
    GetBalanceByUserIdResponseFromJSON,
    GetBalanceByUserIdResponseToJSON,
    GetBalanceDetailResponseFromJSON,
    GetBalanceDetailResponseToJSON,
    GetBalanceResponseFromJSON,
    GetBalanceResponseToJSON,
    GetBalanceStatementByStudentRequestFromJSON,
    GetBalanceStatementByStudentRequestToJSON,
    GetBalanceStatementByUserRequestFromJSON,
    GetBalanceStatementByUserRequestToJSON,
    PaginatedResultOfGetBalanceDetailResponseFromJSON,
    PaginatedResultOfGetBalanceDetailResponseToJSON,
    PaginatedResultOfGetBalanceResponseFromJSON,
    PaginatedResultOfGetBalanceResponseToJSON,
    PostBalanceTransactionRequestFromJSON,
    PostBalanceTransactionRequestToJSON,
    ResultFromJSON,
    ResultToJSON,
} from '../models/index';

export interface ApiBalanceDetailsIdDeleteRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiBalanceIdDeleteRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiBalanceIdDetailsGetRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiBalanceIdGetRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiBalancePostRequest {
    balanceScrollQuery: BalanceScrollQuery;
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

export interface ApiBalancePostTransactionPostRequest {
    postBalanceTransactionRequest: PostBalanceTransactionRequest;
    xTenantID?: number;
}

export interface ApiBalanceStudentsStudentIdStatementsPostRequest {
    studentId: ApiUserTasksGetPageParameter;
    getBalanceStatementByStudentRequest: GetBalanceStatementByStudentRequest;
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

export interface ApiBalanceSummaryPostRequest {
    balanceScrollQuery: BalanceScrollQuery;
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

export interface ApiBalanceUserIdDetailsGetRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiBalanceUsersUserIdStatementsPostRequest {
    userId: ApiUserTasksGetPageParameter;
    getBalanceStatementByUserRequest: GetBalanceStatementByUserRequest;
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

/**
 * 
 */
export class BalanceApi extends runtime.BaseAPI {

    /**
     * Deletes a balance line. This action is irreversible.
     * Delete a balance line
     */
    async apiBalanceDetailsIdDeleteRaw(requestParameters: ApiBalanceDetailsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiBalanceDetailsIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/balance/details/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a balance line. This action is irreversible.
     * Delete a balance line
     */
    async apiBalanceDetailsIdDelete(requestParameters: ApiBalanceDetailsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiBalanceDetailsIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes a balance and all associated balance lines. This action is irreversible and should be used with caution.
     * Delete a balance
     */
    async apiBalanceIdDeleteRaw(requestParameters: ApiBalanceIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiBalanceIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/balance/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a balance and all associated balance lines. This action is irreversible and should be used with caution.
     * Delete a balance
     */
    async apiBalanceIdDelete(requestParameters: ApiBalanceIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiBalanceIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves the balance details associated with the specified balance unit ID.
     * Gets balance details by balance unit ID
     */
    async apiBalanceIdDetailsGetRaw(requestParameters: ApiBalanceIdDetailsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetBalanceDetailResponse>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiBalanceIdDetailsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/balance/{id}/details`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetBalanceDetailResponseFromJSON));
    }

    /**
     * Retrieves the balance details associated with the specified balance unit ID.
     * Gets balance details by balance unit ID
     */
    async apiBalanceIdDetailsGet(requestParameters: ApiBalanceIdDetailsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetBalanceDetailResponse>> {
        const response = await this.apiBalanceIdDetailsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the balance information associated with the specified ID.
     * Gets balance by ID
     */
    async apiBalanceIdGetRaw(requestParameters: ApiBalanceIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBalanceResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiBalanceIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/balance/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBalanceResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves the balance information associated with the specified ID.
     * Gets balance by ID
     */
    async apiBalanceIdGet(requestParameters: ApiBalanceIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBalanceResponse> {
        const response = await this.apiBalanceIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a paginated list of balances.
     * Gets paginated balances
     */
    async apiBalancePostRaw(requestParameters: ApiBalancePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetBalanceDetailResponse>> {
        if (requestParameters['balanceScrollQuery'] == null) {
            throw new runtime.RequiredError(
                'balanceScrollQuery',
                'Required parameter "balanceScrollQuery" was null or undefined when calling apiBalancePost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/balance`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BalanceScrollQueryToJSON(requestParameters['balanceScrollQuery']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetBalanceDetailResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a paginated list of balances.
     * Gets paginated balances
     */
    async apiBalancePost(requestParameters: ApiBalancePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetBalanceDetailResponse> {
        const response = await this.apiBalancePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create balance transaction for a user\'s account without processing a payment. Used for manual adjustments or corrections.
     * Create balance transaction
     */
    async apiBalancePostTransactionPostRaw(requestParameters: ApiBalancePostTransactionPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['postBalanceTransactionRequest'] == null) {
            throw new runtime.RequiredError(
                'postBalanceTransactionRequest',
                'Required parameter "postBalanceTransactionRequest" was null or undefined when calling apiBalancePostTransactionPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/balance/post-transaction`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostBalanceTransactionRequestToJSON(requestParameters['postBalanceTransactionRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create balance transaction for a user\'s account without processing a payment. Used for manual adjustments or corrections.
     * Create balance transaction
     */
    async apiBalancePostTransactionPost(requestParameters: ApiBalancePostTransactionPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiBalancePostTransactionPostRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves a paginated balance statement for the specified student.
     * Gets balance statements for a student
     */
    async apiBalanceStudentsStudentIdStatementsPostRaw(requestParameters: ApiBalanceStudentsStudentIdStatementsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BalanceUnitStatement>> {
        if (requestParameters['studentId'] == null) {
            throw new runtime.RequiredError(
                'studentId',
                'Required parameter "studentId" was null or undefined when calling apiBalanceStudentsStudentIdStatementsPost().'
            );
        }

        if (requestParameters['getBalanceStatementByStudentRequest'] == null) {
            throw new runtime.RequiredError(
                'getBalanceStatementByStudentRequest',
                'Required parameter "getBalanceStatementByStudentRequest" was null or undefined when calling apiBalanceStudentsStudentIdStatementsPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/balance/students/{studentId}/statements`;
        urlPath = urlPath.replace(`{${"studentId"}}`, encodeURIComponent(String(requestParameters['studentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetBalanceStatementByStudentRequestToJSON(requestParameters['getBalanceStatementByStudentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BalanceUnitStatementFromJSON(jsonValue));
    }

    /**
     * Retrieves a paginated balance statement for the specified student.
     * Gets balance statements for a student
     */
    async apiBalanceStudentsStudentIdStatementsPost(requestParameters: ApiBalanceStudentsStudentIdStatementsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BalanceUnitStatement> {
        const response = await this.apiBalanceStudentsStudentIdStatementsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a paginated list of balance summaries.
     * Gets paginated balance summary
     */
    async apiBalanceSummaryPostRaw(requestParameters: ApiBalanceSummaryPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetBalanceResponse>> {
        if (requestParameters['balanceScrollQuery'] == null) {
            throw new runtime.RequiredError(
                'balanceScrollQuery',
                'Required parameter "balanceScrollQuery" was null or undefined when calling apiBalanceSummaryPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/balance/summary`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BalanceScrollQueryToJSON(requestParameters['balanceScrollQuery']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetBalanceResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a paginated list of balance summaries.
     * Gets paginated balance summary
     */
    async apiBalanceSummaryPost(requestParameters: ApiBalanceSummaryPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetBalanceResponse> {
        const response = await this.apiBalanceSummaryPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the balance details associated with the specified user ID.
     * Gets balance details by user ID
     */
    async apiBalanceUserIdDetailsGetRaw(requestParameters: ApiBalanceUserIdDetailsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetBalanceByUserIdResponse>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiBalanceUserIdDetailsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/balance/user/{id}/details`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetBalanceByUserIdResponseFromJSON));
    }

    /**
     * Retrieves the balance details associated with the specified user ID.
     * Gets balance details by user ID
     */
    async apiBalanceUserIdDetailsGet(requestParameters: ApiBalanceUserIdDetailsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetBalanceByUserIdResponse>> {
        const response = await this.apiBalanceUserIdDetailsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a paginated balance statement for the specified user.
     * Gets balance statements for a user
     */
    async apiBalanceUsersUserIdStatementsPostRaw(requestParameters: ApiBalanceUsersUserIdStatementsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BalanceUnitStatement>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiBalanceUsersUserIdStatementsPost().'
            );
        }

        if (requestParameters['getBalanceStatementByUserRequest'] == null) {
            throw new runtime.RequiredError(
                'getBalanceStatementByUserRequest',
                'Required parameter "getBalanceStatementByUserRequest" was null or undefined when calling apiBalanceUsersUserIdStatementsPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/balance/users/{userId}/statements`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetBalanceStatementByUserRequestToJSON(requestParameters['getBalanceStatementByUserRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BalanceUnitStatementFromJSON(jsonValue));
    }

    /**
     * Retrieves a paginated balance statement for the specified user.
     * Gets balance statements for a user
     */
    async apiBalanceUsersUserIdStatementsPost(requestParameters: ApiBalanceUsersUserIdStatementsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BalanceUnitStatement> {
        const response = await this.apiBalanceUsersUserIdStatementsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
